import SurveyForm from "../components/SurveyForm";

const EditStandardSurveyPage = () => <SurveyForm mode="standard" />;

export default EditStandardSurveyPage;
